export default __webpack_public_path__ + "static/BHM_TeenVogue_Banners_2400x565-d71c53d8c7283ba43985253b01ebc5f9.jpg";